import request from '@/fetch/index'

// 获取首页信息展示
export function getBigscreenStatistic (params) {
  return request({
    url: '/api/loan/statistic/bigscreen',
    methods: 'GET',
    params
  })
}
